import AppDispatcher from '../dispatcher/AppDispatcher';
import { EventEmitter } from 'events';
import MoveMoneyPayeeConstants from '../constants/MoveMoneyPayeeConstants';
import SessionConstants from '../constants/SessionConstants';
import MoveMoneyConstants from '../constants/MoveMoneyConstants';
import MoveMoneyPayeeApiUtils from '../utils/MoveMoneyPayeeApiUtils';
import AccountsStore from './AccountsStore';
import MoveMoneyStore from './MoveMoneyStore';
import AppConstants, { CHANGE_EVENT } from '../constants/AppConstants';
import _, { get } from 'lodash';
import StringConstant from '../constants/StringConstants';
import MoveMoneyBL from '../components/movemoney/MoveMoneyBL';

let _payeeList = [];
let _addPayeeResponse = [];
let _addCompanyPayeeResponse = [];
let _companyResponse = [];
let _companyAdded = false;
let _toSelectedAccount = {};
let _fieldValue = {
  single_use: false,
  name: '',
  display_name: '',
};

let _companyFieldValue = {
  single_use: false,
  display_name: '',
  biller_id: '',
  company_name: '',
};
let _addedCompanyObject = null;
let accountNumber = '';
let sortCode = '';
let referenceData = '';
let _editPayeeResponse = {};
let _deletePayeeResponse = {};
let _payeeAdded = false;
let _payeeEdited = false;
let accountId = null;
let beneficiaryId = null;
let billerId = null;
let billerEdit = null;
let _deletePayeeLoader = false;
let _fieldValueOld = {
  single_use: false,
  name: '',
  display_name: '',
};
let disableUpdate = true;
let enableResponse = true;
let oldPayeeData = {};
let isErrorToAddPayeeWhileEdit = false;
let isErrorToAddCompanyWhileEdit = false;
let oldCompanyData = {};
let addPayeeWhileEdit = false;
let showSummaryPageAfterEditBiller = true;
// Avadhut: This flag is added for BOW-2635 purpose
let showSummaryPageAfterSecondAdd = true;
let showSummaryPageAfterPayeeAdd = true;
let _copCheckPerformed = false;
let addPayeeDetails = {};
let _srdOutcome = {};
let _copCheckNeeded = '';
let billerReferenceDescription = '';
let _unauthorisedBeneficiaryDetails = null;
let _isLoading = false;

const normaliseNewPayee = (actionData) => {
  const payeeDetails = {
    display_name: actionData.display_name,
    reference: actionData.reference || '',
    cop_account_type: actionData.cop_account_type,
    cop_account_name: actionData.cop_account_name,
    confirmation_of_payee: actionData.confirmation_of_payee,
    singleUse: _fieldValue['single_use'],
  };

  if (actionData.id) {
    payeeDetails.id = actionData.id;
  }

  payeeDetails.to_account = {
    name: actionData.name,
    sort_code: actionData.sort_code,
    account_number: actionData.account_number,
  };

  const fromAccount = AccountsStore.getAccountDetail(actionData.accountId);
  payeeDetails.account = {
    id: fromAccount.id,
    sort_code: fromAccount.sortCode,
    account_number: fromAccount.number,
  };

  return payeeDetails;
};

class MoveMoneyPayeeStore extends EventEmitter {
  constructor() {
    super();
    this.dispatchToken = AppDispatcher.register(
      this.dispatcherCallback.bind(this)
    );
  }

  emitChange() {
    this.emit(CHANGE_EVENT);
  }

  /**
   * Allow views to specify functions to run when this store changes.
   *
   * @param {function} callback    Function to run on change.
   */
  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  }

  /**
   * Allow views to unbind listeners before dismounting.
   *
   * @param  {Function} callback    Function to unbind.
   */
  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  }

  /**
   * get the added payee response
   *
   * @return {Any}        payee response.
   */
  getAddPayeeResponse() {
    return _addPayeeResponse || {};
  }

  /**
   * get the all payee
   *
   * @return {Any}        payee list.
   */
  getAllPayees() {
    return _payeeList || [];
  }

  /**
   * get the filed value for name
   * @param {name}  name of form field
   * @return {Any}    The corresponding value
   */
  getFieldValue(name) {
    return _fieldValue[name];
  }

  getSRDResponse() {
    return _srdOutcome || {};
  }
  /**
   * validate whether payee can be submitted
   *
   * @return {Any}      The corresponding value
   */
  isPayeeSubmit() {
    let isValid = true;
    Object.keys(_fieldValue).forEach((key) => {
      const value = _.toString(_fieldValue[key]);
      if (value.trim().length < 1) {
        isValid = false;
      }
    });
    return isValid;
  }

  getSelectedAccount() {
    return _toSelectedAccount;
  }

  getCompanyResponse() {
    return _companyResponse || {};
  }

  getAddCompanyPayeeResponse() {
    return _addCompanyPayeeResponse || {};
  }

  emptySearchCompanyData() {
    _companyResponse = [];
  }

  nameCompanyUpdate() {
    return _companyFieldValue;
  }

  nameUpdate() {
    return _fieldValue;
  }

  accountNumberUpdate() {
    return accountNumber;
  }

  sortCodeUpdate() {
    return sortCode;
  }

  referenceUpdate() {
    return referenceData;
  }

  editPayeeResponse() {
    return _editPayeeResponse;
  }

  deletePayeeResponseForMoveMoney() {
    return _deletePayeeResponse;
  }

  getAddPayeeFlag() {
    return _payeeAdded;
  }

  getEditPayeeFlag() {
    return _payeeEdited;
  }

  getCompanyAddedFlag() {
    return _companyAdded;
  }

  getDeletePayeeLoader() {
    return _deletePayeeLoader;
  }

  resetEditPaymentResponse() {
    _editPayeeResponse = {};
    _deletePayeeResponse = {};
  }

  setCompanyObject(val) {
    _addedCompanyObject = val;
  }

  setDefaultAccount(val) {
    // for adding ben out of payment flow
    _toSelectedAccount = val;
  }

  getCopCheckNeeded() {
    return _copCheckNeeded;
  }

  getCompanyDetails() {
    return _addedCompanyObject;
  }

  resetStore() {
    _payeeList = [];
    _addPayeeResponse = [];
    _addCompanyPayeeResponse = [];
    _companyResponse = [];
    _addedCompanyObject = null;
    // _toSelectedAccount = {};
    _fieldValue = {
      single_use: false,
      name: '',
      display_name: '',
    };
    _companyFieldValue = {
      single_use: false,
      display_name: '',
    };
    accountNumber = '';
    sortCode = '';
    referenceData = '';
    _editPayeeResponse = {};
    _deletePayeeResponse = {};
    _payeeAdded = false;
    _payeeEdited = false;
    _companyAdded = false;
    _copCheckNeeded = '';
    _deletePayeeLoader = false;
    disableUpdate = true;
    _unauthorisedBeneficiaryDetails = null;
    _isLoading = false;
    this.emitChange();
  }

  resetFlags() {
    _payeeAdded = false;
    _payeeEdited = false;
    _companyAdded = false;
    this.emitChange();
  }

  isUpdateEnable() {
    return disableUpdate;
  }

  isEnableResponse() {
    return enableResponse;
  }

  storeEditPayeeData(data) {
    oldPayeeData = data;
  }

  errorToAddPayee(value) {
    isErrorToAddPayeeWhileEdit = value;
  }

  errorToAddCompany(value) {
    isErrorToAddCompanyWhileEdit = value;
  }

  storeEditBillerData(data) {
    oldCompanyData = data;
  }

  handlingErrorWhilePayeeEdit(value) {
    addPayeeWhileEdit = value;
  }

  showSummaryPageAfterEditBiller() {
    return showSummaryPageAfterEditBiller;
  }

  showSummaryPageAfterSecondAdd() {
    return showSummaryPageAfterSecondAdd;
  }
  hasCopCheckPerformed() {
    return _copCheckPerformed;
  }

  getAddPayeeDetails() {
    return addPayeeDetails;
  }

  getBillerReferenceDescription() {
    return billerReferenceDescription;
  }

  setBillerReferenceDescription(referenceDescription) {
    billerReferenceDescription = referenceDescription;
  }

  getUnauthorisedBeneficiaryDetails() {
    return _unauthorisedBeneficiaryDetails;
  }

  getAccountId() {
    return accountId;
  }

  isLoading() {
    return _isLoading;
  }

  dispatcherCallback(data) {
    const actionType = data.action.actionType;
    const actionData = data.action.data;
    switch (actionType) {
      case MoveMoneyPayeeConstants.MOVEMONEY_COMPANY_SEARCH: // search company
        MoveMoneyPayeeApiUtils.getCompany(Object.assign({}, actionData));
        break;

      case MoveMoneyPayeeConstants.MOVEMONEY_ADD_COMPANY_PAYEE_SERVICECALL:
        const companyData = Object.assign({}, _companyFieldValue, actionData);
        if (!_.isEmpty(MoveMoneyStore.getSelectedAccount())) {
          _toSelectedAccount = MoveMoneyStore.getSelectedAccount();
        }
        MoveMoneyPayeeApiUtils.addCompany(companyData, _toSelectedAccount.id);

        break;
      case MoveMoneyPayeeConstants.MOVEMONEY_ADD_PAYEE_SERVICECALL:
        _isLoading = true;

        _fieldValue.name = get(
          actionData,
          'cop_account_name',
          _fieldValue.name
        );
        if (_fieldValue.name && _fieldValue.name.length > 50) {
          const updatedFieldValue = {
            account_number: _fieldValue.account_number,
            display_name: _fieldValue?.display_name?.trim(),
            name: _fieldValue.name.substring(0, 50).trim(),
            reference: _fieldValue?.reference?.trim(),
            single_use: _fieldValue.single_use,
            sort_code: _fieldValue.sort_code,
          };

          const payeeData = MoveMoneyBL.validateReferenceKey({
            ...updatedFieldValue,
            ...actionData,
          });
          if (!_.isEmpty(MoveMoneyStore.getSelectedAccount())) {
            _toSelectedAccount = MoveMoneyStore.getSelectedAccount();
          }
          MoveMoneyPayeeApiUtils.addPayee(payeeData, _toSelectedAccount.id);
        } else {
          const payeeData = MoveMoneyBL.validateReferenceKey({
            ..._fieldValue,
            ...actionData,
          });
          if (!_.isEmpty(MoveMoneyStore.getSelectedAccount())) {
            _toSelectedAccount = MoveMoneyStore.getSelectedAccount();
          }
          MoveMoneyPayeeApiUtils.addPayee(payeeData, _toSelectedAccount.id);
        }
        break;
      case MoveMoneyPayeeConstants.MOVEMONEY_UPDATE_ADD_COMPANY_MANUALLY:
        _fieldValue = actionData;
        addPayeeDetails = actionData;
        break;

      case MoveMoneyPayeeConstants.MOVEMONEY_ADD_PAYEE_SUCCESS:
        _isLoading = false;

        if (showSummaryPageAfterPayeeAdd) {
          showSummaryPageAfterEditBiller = true;
        }
        if (!showSummaryPageAfterPayeeAdd) {
          showSummaryPageAfterPayeeAdd = true;
        }
        beneficiaryId = actionData.id;
        _addPayeeResponse = actionData;

        const payeeDetails = normaliseNewPayee(actionData);

        if (!addPayeeWhileEdit) {
          _payeeAdded = true;
          MoveMoneyStore.setSelectedPayee(payeeDetails);
        }

        const missingCOPData =
          _.isEmpty(payeeDetails.cop_account_type) ||
          payeeDetails?.confirmation_of_payee?.cop_status ===
            StringConstant.COP_INACTIVE ||
          _.isEmpty(payeeDetails.cop_account_name);

        if (missingCOPData) {
          _copCheckNeeded = true;
        }

        MoveMoneyStore.updatePayeeList(payeeDetails);
        _editPayeeResponse = actionData;
        _copCheckPerformed = true;

        this.emitChange();
        break;
      case MoveMoneyPayeeConstants.MOVEMONEY_PUT_PAYEE_SUCCESS: {
        _isLoading = false;

        const { initialBeneficiaryId, ...restOfActionData } = actionData;

        _editPayeeResponse = restOfActionData;
        _payeeEdited = true;

        const payeeDetails = normaliseNewPayee(restOfActionData);

        const missingCOPData =
          _.isEmpty(payeeDetails.cop_account_type) ||
          payeeDetails?.confirmation_of_payee?.cop_status ===
            StringConstant.COP_INACTIVE ||
          _.isEmpty(payeeDetails.cop_account_name);

        if (missingCOPData) {
          _copCheckNeeded = true;
        }

        showSummaryPageAfterPayeeAdd = true;

        MoveMoneyStore.setSelectedPayee(payeeDetails);
        MoveMoneyStore.updateSinglePayee(initialBeneficiaryId, payeeDetails);

        this.emitChange();
        break;
      }
      case MoveMoneyPayeeConstants.MOVEMONEY_PUT_PAYEE_ERROR: {
        _isLoading = false;

        const { _initialBeneficiaryId, ...restOfActionData } = actionData;
        _editPayeeResponse = restOfActionData;

        this.emitChange();
        break;
      }
      // handle add company payee success response
      case MoveMoneyPayeeConstants.MOVEMONEY_ADD_COMPANY_SUCCESS:
        _isLoading = false;

        if (showSummaryPageAfterSecondAdd) {
          showSummaryPageAfterEditBiller = true;
        }
        if (!showSummaryPageAfterSecondAdd) {
          showSummaryPageAfterSecondAdd = true;
        }
        beneficiaryId = actionData.id;
        _addCompanyPayeeResponse = actionData;
        const payeeDetails1 = {
          id: actionData.id,
          display_name: actionData.display_name,
          reference: actionData.reference,
          cop_account_name: actionData.cop_account_name,
          cop_account_type: actionData.cop_account_type,
          confirmation_of_payee: actionData.confirmation_of_payee,
        };
        const payeeAccount1 = AccountsStore.getAccountDetail(
          actionData.accountId
        );
        payeeDetails1.account = {
          id: payeeAccount1.id,
          sort_code: payeeAccount1.sortCode,
          account_number: payeeAccount1.number,
        };
        if (_addedCompanyObject != null) {
          if (_addedCompanyObject.hasOwnProperty('billerId')) {
            payeeDetails1.to_account = {
              name: _addedCompanyObject.fieldValue.name,
              sort_code: _addedCompanyObject.fieldValue.sort_code,
              account_number: _addedCompanyObject.fieldValue.account_number,
            };
            payeeDetails1.biller_id = _addedCompanyObject.billerId;
            payeeDetails1.singleUse = _addedCompanyObject.fieldValue.single_use;
          } else {
            payeeDetails1.to_account = {
              name: _addedCompanyObject['company_name'],
              sort_code: _addedCompanyObject['sort_code'],
              account_number: _addedCompanyObject['account_number'],
              biller_id: _addedCompanyObject['biller_id'],
            };
            payeeDetails1.biller_id = _addedCompanyObject['biller_id'];
            payeeDetails1.singleUse = _addedCompanyObject.single_use;
          }
        }

        // _payeeAdded = true;
        _companyAdded = true;

        MoveMoneyStore.setSelectedPayee(payeeDetails1);
        if (!payeeDetails1.singleUse) {
          MoveMoneyStore.updatePayeeList(payeeDetails1);
        }

        _editPayeeResponse = actionData;
        this.emitChange();
        break;
      // handle add payee failure response
      case MoveMoneyPayeeConstants.MOVEMONEY_ADD_PAYEE_FAILURE:
        _isLoading = false;

        showSummaryPageAfterEditBiller = false;
        if (isErrorToAddPayeeWhileEdit === true) {
          let single_uses = false;
          const _fieldValuess = {
            account_number: oldPayeeData.to_account.account_number,
            display_name: oldPayeeData.display_name,
            name: oldPayeeData.to_account.name,
            reference: oldPayeeData.reference,
            single_use: single_uses,
            sort_code: oldPayeeData.to_account.sort_code,
          };

          MoveMoneyPayeeApiUtils.addPayee(_fieldValuess, accountId, false);
          isErrorToAddPayeeWhileEdit = false;
          showSummaryPageAfterSecondAdd = false;
          showSummaryPageAfterPayeeAdd = false;
        }
        _addPayeeResponse = actionData;
        _editPayeeResponse = actionData;
        _payeeAdded = false;
        this.emitChange();
        break;
      case MoveMoneyPayeeConstants.MOVEMONEY_UPDATE_ALL_FORM_VALUES:
        _fieldValue = actionData;
        break;
      // set From selected account for payee
      case MoveMoneyConstants.PUT_SELECTED_ACCOUNT:
        _toSelectedAccount = MoveMoneyStore.getSelectedAccount();
        //= actionData;
        break;
      case MoveMoneyPayeeConstants.MOVEMONEY_DELETE_PAYEE_DETAILS:
        _deletePayeeLoader = true;
        MoveMoneyPayeeApiUtils.deletePayee(actionData);
        this.emitChange();
        break;
      // handle deleted payee success response
      case MoveMoneyPayeeConstants.MOVEMONEY_DELETE_PAYEE_SUCCESS:
        // MoveMoneyApiUtils.getPayeeList(); // No need call payeelist
        MoveMoneyStore.deletePayeeFromList(actionData.beneficiaryId);
        _deletePayeeResponse = actionData;
        _deletePayeeLoader = false;
        _deletePayeeResponse.type = StringConstant.DELETE_PAYEE;
        this.emitChange();
        break;

      case MoveMoneyPayeeConstants.MOVEMONEY_DELETE_PAYEE_FAILED:
        _deletePayeeLoader = false;
        _editPayeeResponse = actionData;
        _deletePayeeResponse = actionData;
        this.emitChange();
        break;

      case MoveMoneyPayeeConstants.MOVEMONEY_UPDATE_EDIT_PAYEE_FORM:
        _fieldValue[actionData.name] = actionData.value;
        if (!_.isEqual(_fieldValue, _fieldValueOld)) {
          disableUpdate = false;
          enableResponse = true;
        } else {
          disableUpdate = true;
          enableResponse = false;
        }
        showSummaryPageAfterSecondAdd = false;
        showSummaryPageAfterPayeeAdd = false;
        showSummaryPageAfterEditBiller = false;
        this.emitChange();

        break;
      case MoveMoneyPayeeConstants.MOVEMONEY_EDIT_PAYEE_SERVICECALL:
        _isLoading = true;

        enableResponse = false;
        if (billerEdit) {
          const editBiller = {
            single_use: false,
            display_name: '',
            biller_id: '',
            company_name: '',
            reference: '',
            cop_account_name: '',
            cop_account_type: '',
            confirmation_of_payee: {},
          };
          editBiller.biller_id = billerId;
          editBiller.company_name = _fieldValue?.name?.substring(0, 50).trim();
          editBiller.reference = _fieldValue?.reference?.trim();
          editBiller.display_name = _fieldValue?.display_name?.trim();
          editBiller.single_use = _fieldValue.single_use;
          editBiller.cop_account_name = get(
            actionData,
            'payeePayload.cop_account_name',
            _fieldValue.cop_account_name
          );
          editBiller.cop_account_type =
            actionData.cop_account_type ||
            actionData.payeePayload.cop_account_type;
          editBiller.confirmation_of_payee =
            actionData.confirmation_of_payee ||
            actionData.payeePayload.confirmation_of_payee;
          MoveMoneyStore.setSelectedPayee(editBiller);
          MoveMoneyPayeeApiUtils.deleteAndPostPayeeSequentially(
            editBiller,
            accountId,
            beneficiaryId
          );
          showSummaryPageAfterEditBiller = true;
        } else {
          if (actionData.currentPayee) {
            beneficiaryId = actionData.currentPayee.id;
          }

          const updatedCopName = get(
            actionData,
            'payeePayload.cop_account_name'
          );

          if (_fieldValue.account_name) {
            _fieldValue.account_name = updatedCopName;
            _fieldValue.name =
              updatedCopName && updatedCopName.substring(0, 50).trim();
          }
          if (_fieldValue.name) {
            _fieldValue.name =
              updatedCopName && updatedCopName.substring(0, 50).trim();
          }

          const _fieldValueNonBiller = Object.assign(
            {},
            {
              account_number: _fieldValue.account_number,
              display_name: _fieldValue?.display_name?.trim(),
              name: _fieldValue?.name?.substring(0, 50).trim(),
              reference: _fieldValue?.reference?.trim(),
              single_use: _fieldValue.single_use,
              sort_code: _fieldValue.sort_code,
            }
          );
          const beneficiaryData = {
            ...MoveMoneyBL.validateReferenceKey(_fieldValueNonBiller),
            ...actionData.payeePayload,
          };

          MoveMoneyStore.setSelectedPayee({
            ...actionData.currentPayee,
            ...beneficiaryData,
            id: beneficiaryId,
          });

          const { enforceSequentialEdit } = actionData;
          MoveMoneyPayeeApiUtils[
            enforceSequentialEdit
              ? 'deleteAndPostPayeeSequentially'
              : 'putRetailPayee'
          ](beneficiaryData, accountId, beneficiaryId);

          const missingCOPData =
            _.isEmpty(beneficiaryData.cop_account_type) ||
            _.isEmpty(beneficiaryData.cop_account_name);
          if (missingCOPData) {
            _copCheckNeeded = true;
          }
          showSummaryPageAfterSecondAdd = true;
          showSummaryPageAfterPayeeAdd = true;
          showSummaryPageAfterEditBiller = true;
        }
        break;
      case MoveMoneyPayeeConstants.MOVEMONEY_UPDATE_ALL_EDIT_FORM_VALUES:
        _fieldValue = actionData.fieldValue;
        _addedCompanyObject = actionData;
        accountId = actionData.accountId;
        beneficiaryId = actionData.beneficiaryId;
        billerId = actionData.billerId;
        billerEdit = actionData.billerEdit;
        break;

      // handle comapny list success
      case MoveMoneyPayeeConstants.MOVEMONEY_COMPANY_DETAILS:
        _companyResponse = actionData;
        this.emitChange();
        break;
      // handle company list error response
      case MoveMoneyPayeeConstants.MOVEMONEY_COMPANY_FAILURE:
        _companyResponse = actionData;
        _payeeAdded = false;
        this.emitChange();
        break;
      // update comapny payee form value
      case MoveMoneyPayeeConstants.MOVEMONEY_UPDATE_ADD_COMPANY_FORM:
        _companyFieldValue = actionData;

        break;
      // handle add company failure response
      case MoveMoneyPayeeConstants.MOVEMONEY_ADD_COMPANY_FAILURE:
        _isLoading = false;

        showSummaryPageAfterSecondAdd = false;
        if (isErrorToAddCompanyWhileEdit) {
          const single_uses = false;
          const editBillers = {
            single_use: false,
            display_name: '',
            biller_id: '',
            company_name: '',
            reference: '',
          };
          editBillers.biller_id = oldCompanyData.biller_id;
          editBillers.company_name = oldCompanyData.to_account.name;
          editBillers.reference = oldCompanyData.reference;
          editBillers.display_name = oldCompanyData.display_name;
          editBillers.single_use = single_uses;
          editBillers.confirmation_of_payee = get(
            actionData,
            'requestData.confirmation_of_payee'
          );
          editBillers.cop_account_name = get(
            actionData,
            'requestData.cop_account_name'
          );
          editBillers.cop_account_type = get(
            actionData,
            'requestData.cop_account_type'
          );
          // const acc_Id = oldCompanyData.to_account.account_number;
          MoveMoneyPayeeApiUtils.addCompany(editBillers, accountId, false);
          isErrorToAddCompanyWhileEdit = false;
          showSummaryPageAfterEditBiller = false;
          showSummaryPageAfterSecondAdd = false;
          showSummaryPageAfterPayeeAdd = false;
        }
        _addCompanyPayeeResponse = actionData;
        _editPayeeResponse = actionData;
        this.emitChange();
        break;
      case AppConstants.LOGOUT_USER:
        this.resetStore();
        this.emitChange();
        break;
      case MoveMoneyPayeeConstants.MOVEMONEY_RESET_PAYEE_DETAILS:
        this.resetStore();
        this.emitChange();
        break;
      case MoveMoneyPayeeConstants.MOVEMONEY_SAVE_ADD_PAYEE_DETAILS:
        const payeeList = MoveMoneyStore.getAllPayees();
        _.map(payeeList.beneficiaries, (payee) => {
          if (payee.id === actionData.id) {
            _fieldValueOld['name'] = payee.to_account.name;
            _fieldValueOld['display_name'] = payee.display_name;
            _fieldValueOld['account_number'] = payee.to_account.account_number;
            _fieldValueOld['reference'] = payee.reference;
            _fieldValueOld['sort_code'] = payee.to_account.sort_code;
            _fieldValueOld['cop_account_name'] = payee.cop_account_name;
          }
        });
        break;
      case MoveMoneyPayeeConstants.MOVEMONEY_SRD_VERIFY:
        MoveMoneyPayeeApiUtils.getSrdDetails(actionData);
        break;
      case MoveMoneyPayeeConstants.MOVEMONEY_SRD_SUCCESS:
        const {
          srd_check_outcome: { cop_check_required },
        } = actionData;
        _copCheckNeeded = cop_check_required;
        this.emitChange();
        break;
      case MoveMoneyPayeeConstants.MOVEMONEY_SRD_FAILURE:
        _copCheckNeeded = false;
        this.emitChange();
        break;
      case MoveMoneyPayeeConstants.MOVEMONEY_STORE_UNAUTHORISED_BENEFICIARY_DETAILS:
        _unauthorisedBeneficiaryDetails = actionData;
        break;
      case SessionConstants.STEP_UP_MODE_INIT:
        _isLoading = false;
        this.emitChange();

        break;
      default:
    }
  }
}

export default new MoveMoneyPayeeStore();
